import { IconSettingsSliderHor } from 'central-icons/IconSettingsSliderHor';

import {
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useDisclosure,
} from '@revelio/ui';

import {
  usePageConfig,
  useTabContentConfig,
} from '../../PageConfigProvider/PageConfigProvider';
import { EnterParametersModal } from './EnterParametersModal';
import { ReportParametersModal } from './ReportParametersModal';
import { useUpdateParameters } from './useUpdateParameters';

export function EditParametersButton() {
  const { config: pageConfig } = usePageConfig();
  const { config: tabContent } = useTabContentConfig();
  const updateParameters = useUpdateParameters();

  const {
    isOpen: isParamsOpen,
    onOpen: onParamsOpen,
    onClose: onParamsClose,
  } = useDisclosure();
  const {
    isOpen: isSelectOpen,
    onOpen: onSelectOpen,
    onClose: onSelectClose,
  } = useDisclosure();

  return (
    <>
      <Menu>
        <MenuButton>
          <Button
            variant="ghost"
            color="secondary"
            shape="squared"
            size="md"
            leftIcon={<IconSettingsSliderHor size={16} />}
            aria-label="Parameter Options"
          >
            Parameters
          </Button>
        </MenuButton>
        <MenuList align="end">
          <MenuItem onClick={onSelectOpen}>Select Current</MenuItem>
          <MenuItem onClick={onParamsOpen}>Edit Parameters</MenuItem>
        </MenuList>
      </Menu>
      <ReportParametersModal
        isOpen={isParamsOpen}
        onClose={onParamsClose}
        defaultValue={tabContent.reportParameters}
        onSave={(params) => {
          updateParameters(params ?? []);
        }}
      />
      <EnterParametersModal
        isOpen={isSelectOpen}
        onClose={onSelectClose}
        pageConfig={pageConfig}
        navigateOnSubmit={false}
      />
    </>
  );
}
